import clsx from 'clsx';
import React from 'react';
import { SVGProps } from 'react';

export interface IconAttributes extends SVGProps<SVGSVGElement> {
  name: string;
  className?: string;
  color?: string;
  size?: string;
}

declare var global: any;

const Icon = (props: IconAttributes) => {
  const { name, className, color, size } = props;

  return (
    <svg
      {...props}
      className={clsx(
        className,
        'site-icon',
        size && 'site-icon--' + size
      )}
      style={{ color: color, fill: color, ...props.style }}
    >
      <use href={`${global.SvgIconsPath}#icon-${name}`}></use>
    </svg>
  );
};

export default Icon;
